<template>
    <div ref="container">
      <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container"
        :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()"
        :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="height: 70%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据编号" prop="code">
                  <a-input placeholder="请输入单据编号" v-model="form.code" onblur="isRepeat"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据日期" prop="date">
                  <JDate placeholder="请填写单据日期" v-model="form.date" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请部门" prop="department">
                  <a-input placeholder="请输入申请部门" v-model="form.department" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人" prop="applicant">
                  <a-input placeholder="请输入申请人" v-model="form.applicant" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物流中心" prop="logistics">
                  <a-input placeholder="请输入物流中心" v-model="form.logistics" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库" prop="warehouse">
                  <a-input placeholder="请输入仓库" v-model="form.warehouse" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="货位" prop="location">
                  <a-input placeholder="请输入货位" v-model="form.location" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="制单人" prop="preparedBy">
                  <a-input placeholder="请输入制单人" v-model="form.preparedBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据时间" prop="preparedTime">
                  <JDate placeholder="请填写制单时间" v-model="form.preparedTime" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { certificateDetail, unqualifiedAdd, unqualifiedEdit } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDate from '../../../components/jeecg/JDate.vue'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
        JImageUpload,
        JDate,
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          registerName: '',
          registerNo: '',
          registerImage: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
        //   registerName: [{ required: true, message: '注册/备案人名称不可为空!' }],
        //   registerNo: [{ required: true, message: '注册/备案编码不可为空!' }],
        //   registerImage: [{ required: true, message: '注册证不可为空!' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, 'form')
        console.log(this.fileList, '数组')
        if (record.id) {
          this.getInfo(record.id)
          this.id = record.id
        } else {
          this.fileList = []
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      async getInfo(id) {
        this.confirmLoading = true
        const res = await certificateDetail({ id })
        console.log(res, 'res---')
        if (res.errno == 200 && res.errmsg == '成功') {
          this.form = res.data
          if (res.data.registerImage) {
            this.fileList = res.data.registerImage
          }
          this.confirmLoading = false
        } else {
          this.$message.error(res.data || res.errmsg)
          this.confirmLoading = false
        }
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            console.log(this.form, 'form---')
            // console.log(this.fileList, '图片数组')
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              code: this.form.code || '',
                date: this.form.date || '',
                preparedTime: this.form.preparedTime || '',
                department: this.form.department || '',
                logistics: this.form.logistics || '',
                applicant: this.form.applicant || '',
                warehouse: this.form.warehouse || '',
                location: this.form.location || '',
                createBy: this.form.createBy || '',
                createTime: this.form.createTime || '',
                preparedBy: this.form.preparedBy || '',
                attachment: this.fileList || '',
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await unqualifiedEdit(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.handleCancel()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            } else {
              const res = await unqualifiedAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.close()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>